import Peer from "peerjs";

export function initPeer() {
  const id = Math.random().toString(36).substr(2, 5);
  let peer;
  if (process.env.NODE_ENV === "development") {
    peer = new Peer(id, {
      host: "localhost",
      port: 9000,
      path: "/peerserver",
    });
  } else {
    peer = new Peer(id, {
      host: process.env.REACT_APP_BASE_URL,
      port: 443,
      secure: true,
      path: "/peerserver",
      debug: 0,
      config: {
        iceServers: [
          { urls: "stun:stun.l.google.com:19302" },
          { urls: "stun:freeturn.net:3478" },
          {
            urls: "turn:freeturn.net:3478",
            username: "free",
            credential: "free",
          },
          {
            urls: "turns:freeturn.net:5349",
            username: "free",
            credential: "free",
          },
        ],
        sdpSemantics: "unified-plan",
      },
    });
  }
  return peer;
}

export default {
  initPeer,
};
